import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'antd';
import Panel from '@/components/Panel';
import Table from "@/components/EditableTable";
import { getComponentByName } from '../../../services/PCBHelper';
import './index.css';
import { getCompPinsNetByCompName } from '../../../services/PCBHelper/net';

const columns = [{
  key: "pin",
  dataIndex: "pin",
  title: "Input",
  width: "50%"
}, {
  key: "pinMap",
  dataIndex: "pinMap",
  title: "Output",
  width: "50%"
}]
class ConnectCMCPinsPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      allCompPinsOption: [],
      pinMap: []
    }
    this.dialogRoot = document.getElementById('root');

    columns[1].onCell = (record) => {
      const { allCompPinsOption } = this.state;
      return {
        record,
        edit: "select",
        options: allCompPinsOption,
        dataIndex: "pinMap",
        getPopupContainer: document.getElementById('root'),
        dropdownMenuClassName: "cmc-components-pins-columns-select-dropdown",
        handleSave: (_record, prevRecord) => { this.editPinMap(_record, prevRecord, "pinMap") },
      }
    }

    columns[1].render = (value, record) => {
      return <Tooltip
        classNames={{ root: "aurora-tooltip" }}
        title={<div>
          <div>Pin Number: {value}</div>
          <div>Pin Name: {record.pinMapInfo.mName}</div>
          <div>Net Name: {record.pinMapInfo.netName}</div>
        </div>}
      >
        <div className="cmc-components-pins-columns">{value}</div>
      </Tooltip>
    }

    columns[0].render = (value, record) => {
      return <Tooltip
        classNames={{ root: "aurora-tooltip" }}
        title={<div>
          <div>Pin Number: {value}</div>
          <div>Pin Name: {record.pinInfo.mName}</div>
          <div>Net Name: {record.pinInfo.netName}</div>
        </div>}
      >
        <div className="cmc-components-pins-columns">{value}</div>
      </Tooltip>
    }

    columns[0].onCell = (record) => {
      const { allCompPinsOption } = this.state;
      return {
        record,
        edit: "select",
        options: allCompPinsOption,
        dataIndex: "pin",
        getPopupContainer: document.getElementById('root'),
        dropdownMenuClassName: "cmc-components-pins-columns-select-dropdown",
        handleSave: (_record, prevRecord) => { this.editPinMap(_record, prevRecord, "pin") },
      }
    }
  }

  editPinMap = (record, prevRecord, type) => {
    const { pinMap } = this.state;
    let _pinMap = [...pinMap];
    const otherType = type === 'pin' ? "pinMap" : 'pin';
    const prevPin = prevRecord[type];
    const prevPinMap = _pinMap.find(item => item[type] === prevRecord[type]) || {};
    const newPin = record[type];
    const newPinMap = _pinMap.find(item => item[otherType] === newPin || item[type] === newPin) || {};
    if (newPinMap[type] === newPin) {
      newPinMap[type] = prevPin;
    } else {
      newPinMap[otherType] = prevPin;
    }
    prevPinMap[type] = newPin;
    this.setState({
      pinMap: _pinMap
    })
  }

  closeModal = () => {
    const { cmcComp } = this.props;
    const { pinMap } = this.state;
    this.props._editCMCCompPinsConnect(cmcComp.part, pinMap);
    this.props.closeModal();
  }

  componentDidMount = () => {
    this.setData();
  }

  componentDidUpdate = (prevProps) => {
    const { cmcComp } = this.props;
    const { cmcComp: prevCmcComp } = prevProps;
    if (cmcComp && (!prevCmcComp || cmcComp.part !== prevCmcComp.part)) {
      this.setData();
    }
  }

  setData = () => {
    const { cmcComp, designId } = this.props;
    if (cmcComp && cmcComp.comps && cmcComp.comps[0]) {
      const pcbComp = getComponentByName(designId, cmcComp.comps[0].name);
      const mPinList = pcbComp.mPart && pcbComp.mPart.mPinList ? pcbComp.mPart.mPinList : [];
      const compPinsNets = getCompPinsNetByCompName(designId, cmcComp.comps[0].name);
      const allCompPinsOption = mPinList.map(pin => {
        const netInfo = compPinsNets[pin.mNumber] || {};
        return { value: pin.mNumber, title: `${pin.mNumber}::${netInfo.mName || ""}`, ...pin, netName: netInfo.mName || "" };
      });

      this.setState({
        allCompPinsOption,
        pinMap: cmcComp.pinsConnection || []
      })
    }
  }

  getTablePins = () => {
    const { pinMap, allCompPinsOption } = this.state;
    let _pinMap = JSON.parse(JSON.stringify(pinMap));
    for (let pin of _pinMap) {
      const findPin = allCompPinsOption.find(item => item.value === pin.pin);
      const findPinMap = allCompPinsOption.find(item => item.value === pin.pinMap);
      pin.pinInfo = findPin;
      pin.pinMapInfo = findPinMap;
    }
    return _pinMap;
  }

  render = () => {
    const { cmcComp } = this.props;
    const dataList = this.getTablePins()
    const content = (
      <Panel
        className='andes-create-channel-panel'
        position='panel-center-left'
        title={`Pins Connections - ${cmcComp.part}`}
        zIndex={2000}
        onCancel={() => { this.closeModal() }}
        width={600}
        draggable
        minHeight={200}
      >
        <div className='create-channel-content'>
          <Table
            ref={(ref) => this.table = ref}
            columns={columns}
            dataSource={dataList}
            rowKey="pin"
          />
        </div>
      </Panel>
    )
    return createPortal(content, this.dialogRoot)
  }
}


export default ConnectCMCPinsPanel;